export class AppError extends Error {
  constructor(
    message: string,
    public readonly code?: string,
    public readonly originalError?: unknown
  ) {
    super(message);
    this.name = 'AppError';
  }
}

export function handleAsyncError(error: unknown, context: string): never {
  console.error(`Error in ${context}:`, error);
  
  if (error instanceof AppError) {
    throw error;
  }
  
  if (error instanceof Error) {
    throw new AppError(error.message, undefined, error);
  }
  
  throw new AppError('An unknown error occurred', undefined, error);
} 